import { HttpInterceptorFn } from '@angular/common/http';

/** Reemplazo de `mock-interceptors.ts` en los entornos desplegados: sin backend simulado. */
export const mockInterceptors: HttpInterceptorFn[] = [];
